const TOKEN_STORAGE_KEY = "token";

let accessTokenGetter = null;

const canUseLocalStorage = () => typeof window !== "undefined" && window.localStorage;

export const getAuthAudience = () => process.env.REACT_APP_AUDIENCE_URL;

export const setAccessTokenGetter = (getter) => {
  accessTokenGetter = typeof getter === "function" ? getter : null;
};

export const clearAccessTokenGetter = () => {
  accessTokenGetter = null;
};

export const getStoredAccessToken = () => {
  if (!canUseLocalStorage()) return null;
  return window.localStorage.getItem(TOKEN_STORAGE_KEY);
};

export const setStoredAccessToken = (token) => {
  if (!canUseLocalStorage()) return;
  if (token) {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }
};

export const clearStoredAccessToken = () => {
  if (!canUseLocalStorage()) return;
  window.localStorage.removeItem(TOKEN_STORAGE_KEY);
};

export const isSessionExpiredPayload = (payload) => {
  const responseName = payload?.name;
  const responseMessage = String(payload?.message || "").toLowerCase();

  return (
    responseName === "TokenExpiredError" ||
    responseMessage.includes("invalid session") ||
    responseMessage.includes("session expired")
  );
};

export const isSessionExpiredResponse = (response) => {
  return isSessionExpiredPayload(response?.data) || response?.status === 401;
};

//function to identify Auth0 refresh-token rotation failures
export const isInvalidGrantError = (error) => {
  const errorText = [
    error?.error,
    error?.error_description,
    error?.message,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return errorText.includes("invalid_grant") || errorText.includes("invalid refresh token");
};

export const getFreshAccessToken = async ({ forceRefresh = false } = {}) => {
  if (accessTokenGetter) {
    try {
      const token = await accessTokenGetter({ forceRefresh });
      if (token) {
        setStoredAccessToken(token);
        return token;
      }
    } catch (error) {
      if (isInvalidGrantError(error)) {
        clearStoredAccessToken();
        throw error;
      }

      const storedToken = getStoredAccessToken();
      if (!storedToken && forceRefresh) {
        throw error;
      }
    }
  }

  return getStoredAccessToken();
};

export const refreshAccessToken = async () => {
  return getFreshAccessToken({ forceRefresh: true });
};

export const forceAuthLogout = () => {
  clearStoredAccessToken();
  if (typeof window !== "undefined" && window.location.pathname !== "/logout") {
    window.location.pathname = "/logout";
  }
};
